import { useState, useEffect } from 'react';

export function useScrollBehavior(threshold = 50) {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Calculate scroll progress (0 to 1)
      const progress = Math.min(currentScrollY / threshold, 1);
      setScrollProgress(progress);
      
      // Always keep the header visible
      setIsVisible(true);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return { scrollProgress, isVisible };
}